import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import rem from './utils/rem'

createApp(App).use(rem).use(store).use(router).mount('#app')
